document.addEventListener("DOMContentLoaded", function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const accordionItem = this.parentElement;
      const isActive = accordionItem.classList.contains('active');

      // Cerrar todos los paneles
      accordionHeaders.forEach(header => {
        header.parentElement.classList.remove('active');
      });

      // Abrir solo el panel clicado
      if (!isActive) {
        accordionItem.classList.add('active');
      }
    });
  });
});


